import { ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV } from '@atlassian/jira-common-constants/src/spa-routes.tsx';

export const legacyProjectSettingsDevRoute = {
	name: ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV,
	path: '/secure/ConfigureDevStatus.jspa',
	query: ['projectKey'],
};
